var ProductDetailsData = React.createContext({});
export var ProductDetailsDataProvider = ProductDetailsData.Provider;
export var ProductDetailsDataConsumer = ProductDetailsData.Consumer;
export default ProductDetailsData;